export default __webpack_public_path__ + "static/book-thumb-2b181af6de7065705972f0a4cf419765.png";